import { resolveColor } from 'src/ui/styles/utils/colors';
import styled from 'styled-components';
import Input from 'ui/atoms/input';

export const Time = styled(Input)`
  border: ${({ theme }) => `1px solid ${resolveColor(theme, 'grayLight')}`};
  border-radius: 0.25rem;
  color: #495057;
  flex-grow: 0;

  &:focus,
  &:active,
  &:focus-visible {
    border-color: #b3ddf3;
    box-shadow: 0 0 0 0.2rem rgb(69 172 226 / 25%);
    outline: 0;
  }
`;
